import { FactOperator } from './fact-operator';

export class MultiplicationOperator implements FactOperator {
	public calculate(values: number[]): number {
		return values.reduce((val1, val2) => val1 * val2, 1);
	}
}
